import { gql } from '@apollo/client';

export const FRAGMENT_SOLUTION_SYSTEM = gql`
  fragment SolutionSystemFields on SolutionSystem {
    name
    urlCode
    solutionSystemIdentifier
  }
`;
